(function () {
    'use strict';
    angular
        .module('app.widgets')
        .directive('affixTarget', affixTarget)
        .directive('affixContainer', affixContainer)
        .directive('affixTop', affixTop)
        .directive('affixBottom', affixBottom);



    function affixTarget(){
        return {
            restrict : 'A',
            require: '?^affixContainer', /*optional*/
            link : function linkFn(scope, element, attrs, affixContainerCtrl){
                affixContainerCtrl.setTarget(element);
            }
        }
    }

    /*@ngInject*/
    function affixContainerCtrl(){
        var vm = this;
        vm.top=null;
        vm.bottom=null;
        vm.target = null;

        vm.getOffset= getOffset;
        vm.setTop = setTop;
        vm.setBottom = setBottom;
        vm.setTarget = setTarget;

        function setTarget(target){
            vm.target = target;
        }
        function getOffset(windowHeight){
            var top = vm.top ? vm.top.offset().top : null;
            var containerSize = vm.bottom ? vm.bottom.outerHeight(true) : null;
            var bottom = windowHeight - top - containerSize;

            if(top && vm.affixMargin && vm.affixMargin.top){
                top -= vm.affixMargin.top;
                console.log('-50 pon top', vm.affixMargin.top )
            }
            if(bottom && vm.affixMargin && vm.affixMargin.bottom){
                bottom += vm.affixMargin.bottom;
            }
            return {
                top:top - 50,
                bottom: bottom
            };
        }
        function setTop(data){
            vm.top = data;
        }
        function setBottom(data){
            vm.bottom = data;
        }
    }
    function affixContainer($timeout, $window, $document){
        return {
            restrict : 'A',
            controller:affixContainerCtrl,
            link:affixContainerLink
//            require: '?^obtModalPopups' /*optional*/
        };

        function affixContainerLink(scope,elem,attr,ctrl){
            scope.vm.affixMargin = {top     : attr.affixMarginTop || 0,
                                    bottom  : attr.affixMarginBottom || 0};

            if(!ctrl.target){
                return;
            }
            var listener  = scope.$on(attr.dataLoadedEvent ? attr.dataLoadedEvent : 'dataloaded', function () {
                $timeout(function () { // You might need this timeout to be sure its run after DOM render.
                    setAffix(ctrl);
                    angular.element($window).bind('resize', function() {
                        setAffix(ctrl);
                    });
                    listener(); //kill it
                }, 0, false);
            });
        }

        function setAffix(ctrl){
            var target = ctrl.target;
            target.width(target.width()); //set the width
            target.affix({
                offset: ctrl.getOffset($document[0].body.offsetHeight)
            });
        }
    }
    function affixTop(){
        return {
            restrict : 'A',
            require: '?^affixContainer', /*optional*/
            link : function linkFn(scope, element, attrs, affixContainerCtrl){
                if(affixContainerCtrl){
                    affixContainerCtrl.setTop(element);
                }

//                offset.top =  attrs.offsetTop || element.offset().top;
            }
        }
    }
    function affixBottom(){
        return {
            restrict : 'A',
            require: '?^affixContainer', /*optional*/
            link : function linkFn(scope, element, attrs, affixContainerCtrl){
                if(affixContainerCtrl){
                    affixContainerCtrl.setBottom(element);
                }
//                offset.bottom =  attrs.offsetBottom || outerHeight(true);
            }
        }
    }
})();




/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-affix-target.directive.js
 ** module id = 183
 ** module chunks = 0
 **/